import React from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';

const MessageVoting = ({ messageId, userVote, onVote, onFeedback }) => {
  const handleThumbsUp = () => {
    if (userVote !== 'up') {
      onVote(messageId, 'up');
      // Open feedback modal for thumbs up too
      onFeedback(messageId, 'up');
    }
  };

  const handleThumbsDown = () => {
    if (userVote !== 'down') {
      onVote(messageId, 'down');
      // Open feedback modal for thumbs down
      onFeedback(messageId, 'down');
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <span className="text-xs text-gray-500 mr-2">Was this helpful?</span>
      
      <button
        onClick={handleThumbsUp}
        className={`flex items-center space-x-1 px-2 py-1 rounded-md text-xs transition-colors ${
          userVote === 'up'
            ? 'bg-green-100 text-green-700 border border-green-300'
            : 'text-gray-500 hover:text-green-600 hover:bg-green-50'
        }`}
        title="Thumbs up - This response was helpful"
      >
        <ThumbsUp className="h-3 w-3" />
        <span>Yes</span>
      </button>
      
      <button
        onClick={handleThumbsDown}
        className={`flex items-center space-x-1 px-2 py-1 rounded-md text-xs transition-colors ${
          userVote === 'down'
            ? 'bg-red-100 text-red-700 border border-red-300'
            : 'text-gray-500 hover:text-red-600 hover:bg-red-50'
        }`}
        title="Thumbs down - This response needs improvement"
      >
        <ThumbsDown className="h-3 w-3" />
        <span>No</span>
      </button>
    </div>
  );
};

export default MessageVoting; 